import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import './index.scss'
import IMask from 'imask';
import axios from "axios";
import {Link} from "react-router-dom";

const Final = () => {
    // const [number, setNumber] = useState<any>()


    const mailRef = useRef<any>(null)
    const [mail, setMail] = useState<any>()
    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    const [accepted, setAccepted] = useState(false)
    const [formSubmitted, setFormSubmitted] = useState<boolean>(false)


    const maskOptions = {
        mask: '+{7}(000)000-00-00'
    };
    // if (inputPhone) {
    //     const mask = IMask(inputPhone, maskOptions);
    // }
    // const phoneMask = (phone: any) => {
    //     const regex = /(\d?)(\d{3})(\d{3})(\d{2})(\d{2})/g;
    //     const subst = "+$1 ($2) $3-$4-$5";
    //     return phone.replace(regex, subst);
    // }

    function isEmailValid(value: any) {
        return EMAIL_REGEXP.test(value);
    }

    function onInputEmail() {
        const inputEmail = document.getElementById('mail') as HTMLInputElement;
        if (isEmailValid(inputEmail.value)) {
            console.log(2222)
            inputEmail.style.borderColor = 'green';
            inputEmail.style.color = '#757575';
            setMail(inputEmail.value)

        } else {
            inputEmail.style.borderColor = 'red';
            inputEmail.style.color = 'inherit';
            setMail(null)
        }
    }

    // function onInputPhone() {
    //     const inputPhone = document.getElementById('phone') as HTMLInputElement;
    //     const stringNumber = inputPhone.value.replace(/[^0-9]/g, "")
    //     if (phoneMask(inputPhone.value) && stringNumber.length === 11) {
    //         inputPhone.style.borderColor = 'green';
    //         inputPhone.style.color = '#757575';
    //         setNumber(inputPhone.value)
    //
    //     } else {
    //         inputPhone.style.borderColor = 'red';
    //         inputPhone.style.color = 'inherit';
    //         setNumber(null)
    //     }
    // }

    useEffect(() => {
        const inputEmail = document.getElementById('mail') as HTMLInputElement;
        // const inputPhone = document.getElementById('phone') as HTMLInputElement;
        if(inputEmail ) {
            inputEmail.addEventListener('input', onInputEmail);
            // inputPhone.addEventListener('input', onInputPhone);
        }
        // if (inputPhone) {
        //     const mask = IMask(inputPhone, maskOptions);
        // }
    },[])


    function submitHandler(e: any) {
        if (accepted) {
            e.preventDefault()
            axios.post('https://api.sheetmonkey.io/form/jteGHZ82sA7cA6XKafPbTi', { mail: mail})
                .then(response => {
                    setFormSubmitted(true)
                    // @ts-ignore
                    ym(95273517,'reachGoal','email')
                })
        }
    }


    return (
        <div className={'finalContainer'}>
            <div className={'wrap'}>
                 <div className={'title'}>{!formSubmitted ? 'В НИПИГАЗе тебя ждут профессиональные коллеги, масштабные проекты и поддержка компании.Самое время начать карьеру с преимуществами!' : 'Спасибо! Твоя почта записана.'}</div>
                {!formSubmitted ? '' :  <div className={'title'}>Узнай больше о возможностях в&nbsp;НИПИГАЗе и начинай карьеру с&nbsp;преимуществами уже сейчас!</div>}
                    <button className={'job'} onClick={()=>{
                        window.open('http://career.nipigas.ru/studentam/programma-molodoy-spetsialist/')
                        // @ts-ignore
                        ym(95273517,'reachGoal','vacancy3')
                    }}>К вакансиям!</button>

            {/*</div>*/}
            {/*<div className={`wrap form ${formSubmitted? 'closeForm' : ''}`}>*/}
                {!formSubmitted ?
                    <>
                        <div className={'title'}>
                            Не забудь оставить свои контакты, чтобы участвовать
                            в розыгрыше призов:
                        </div>
                        {/*<input type="text" id='phone' placeholder={'Номер телефона'}/>*/}
                        <input type='email' id='mail' ref={mailRef} placeholder={'Почта'}/>

                        <div className={'acceptedBody'}>
                            <div onClick={() => setAccepted(accepted => !accepted)}
                                 className={`check ${accepted ? 'accepted' : ''}`}/>
                            <div className='text'>Я согласен(а) на <Link to={'https://fut.ru/media/2022/11/personal_data_policy.pdf'}>обработку
                                персональных данных</Link> и получение информационных сообщений
                            </div>
                        </div>
                        <button onClick={ mail ? submitHandler : undefined}
                                className={`next ${formSubmitted ? 'disableForm' : ''}`}>{formSubmitted ? 'Отправлено' : 'Отправить'}</button>
                    </>
                    : ''
                }

            </div>
        </div>
    );
};

export default Final;
